export const syncRecurlyPricingAddress = (recurlyPricing, paymentEntries, onError = () => {}) => {
  if (!recurlyPricing || typeof recurlyPricing.address !== 'function') {
    return
  }

  const { country, zip } = paymentEntries || {}
  recurlyPricing
    .address({
      country,
      postal_code: zip,
    })
    .catch(error => onError(error))
    .done()
}
